"use strict";
'use client';
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var next_intl_1 = require("next-intl");
var react_1 = __importStar(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var InputAmount = function (_a) {
    var isDisabled = _a.isDisabled, hasError = _a.hasError, tooltip = _a.tooltip, errortext = _a.errortext, helpertext = _a.helpertext, placeholder = _a.placeholder, className = _a.className, withClear = _a.withClear, withMax = _a.withMax, max = _a.max, _b = _a.errorTextCentered, errorTextCentered = _b === void 0 ? false : _b, _c = _a.hasPlaceholder, hasPlaceholder = _c === void 0 ? false : _c, props = __rest(_a, ["isDisabled", "hasError", "tooltip", "errortext", "helpertext", "placeholder", "className", "withClear", "withMax", "max", "errorTextCentered", "hasPlaceholder"]);
    var ref = (0, react_1.useRef)(null);
    var t = (0, next_intl_1.useTranslations)('translation');
    var _d = (0, react_1.useState)(false), focus = _d[0], setFocus = _d[1];
    var onFocus = function (e) {
        setFocus(true);
        props === null || props === void 0 ? void 0 : props.onFocus(e);
    };
    var onBlur = function (e) {
        setFocus(false);
        props === null || props === void 0 ? void 0 : props.onBlur(e);
    };
    return (react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.inputWrapper, " ").concat(className) },
        react_1.default.createElement("div", null,
            react_1.default.createElement("input", __assign({ ref: ref, className: "".concat(styles_module_scss_1.default.input, " ").concat((errortext === null || errortext === void 0 ? void 0 : errortext.status) === 'error' ? styles_module_scss_1.default.error : '') }, props, { placeholder: "", disabled: isDisabled, onFocus: onFocus, onBlur: onBlur })),
            (!isDisabled || hasPlaceholder) &&
                !props.value &&
                props.value !== '0' &&
                props.value !== 0 &&
                !focus && (react_1.default.createElement("span", { onClick: function (e) {
                    var _a;
                    if (isDisabled)
                        return;
                    (_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.focus();
                    props === null || props === void 0 ? void 0 : props.onFocus(e);
                    setFocus(true);
                }, className: styles_module_scss_1.default.placeholder }, placeholder)),
            withMax && !props.value && !isDisabled && (react_1.default.createElement("div", { onClick: function () { return props.onChange({ target: { value: max } }); }, className: styles_module_scss_1.default.withMax }, "Max")),
            withClear && props.value && !isDisabled ? (react_1.default.createElement("div", { onClick: function () { return props.onChange({ target: { value: '' } }); }, className: styles_module_scss_1.default.withClear }, t('clear'))) : null,
            (errortext === null || errortext === void 0 ? void 0 : errortext.status) === 'error' && (react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.errorText, " ").concat(errorTextCentered ? styles_module_scss_1.default.errorTextCentered : '') }, errortext.text)),
            (focus || props.value) && helpertext ? (react_1.default.createElement("div", { className: styles_module_scss_1.default.helperText }, helpertext)) : null)));
};
exports.default = InputAmount;
